import React from "react";

import ButtonWhatsApp from "../../button-whatsapp/ButtonWhatsApp";

import * as S from "./styles";

import loginBanner from "../../../assets/images/login-banner.png";
import { LucralizeLogo } from "../../../assets/svgs";

const LoginDeveloperLayout = ({ children }: any): JSX.Element => (
  <S.Container>
    <S.Header>
      <S.Img src={LucralizeLogo} alt="Lucralize Logo" />
    </S.Header>
    <S.Main>{children}</S.Main>
    <S.Aside>
      <S.Img src={loginBanner} alt="Login Banner" />
    </S.Aside>
    <S.ButtonContainer>
      <ButtonWhatsApp />
    </S.ButtonContainer>
  </S.Container>
);

export default LoginDeveloperLayout;
